import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class FileApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/files' + path, queryMap);
  }

  fileurl(fileid: string) {
    if (fileid.startsWith('http')) {
      return fileid;
    }
    const url = this.buildurl('/' + fileid);
    return url;
  }

  uploadFile(file: any, from: string = '') {
    const url = this.buildurl('/file');
    const body = new FormData();
    body.append('file', file);
    body.append('from', from);
    return this.http.post(url, body);
  }
}
